import { List, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Routes } from '../../../../app/routes';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { setActiveRequestId } from '../../../request/store/requests-slice';
import { SignRequestTableModel } from '../../models/sign-requests-table-model';
import { selectActiveSignRequestId, setActiveSignRequestId } from '../../store/sign-requests-slice';
import styles from './sign-requests-list.module.css';

interface Props {
  isFetchingSignRequests: boolean;
  signRequestsDataSource: SignRequestTableModel[];
}

const SignRequestsList = ({ isFetchingSignRequests, signRequestsDataSource }: Props): JSX.Element => {
  const { t } = useTranslation(['common', 'sign-requests']);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const activeSignRequestId = useAppSelector(selectActiveSignRequestId);
  const navigate = useNavigate();

  return (
    <List
      bordered={true}
      loading={isFetchingSignRequests}
      itemLayout="vertical"
      dataSource={signRequestsDataSource}
      renderItem={record => (
        <List.Item
          className={styles.listItem}
          onClick={() => {
            if (activeSignRequestId === record.id) {
              // Deselect the item when clicked on active
              dispatch(setActiveRequestId(null));
              dispatch(setActiveSignRequestId(null));
              return;
            }
            navigate(Routes.SignRequest.replace(':signRequestId', record.id).replace(':requestId', record.request.id), {
              state: { from: location },
            });
            dispatch(setActiveRequestId(record.request.id));
            dispatch(setActiveSignRequestId(record.id));
          }}
        >
          <div>
            <Typography.Text strong>{t('label.customer')}: </Typography.Text>
            <Typography.Text>{record.customer}</Typography.Text>
          </div>
          <div>
            <Typography.Text strong>{t('signScanRequest.label.signedAt')}: </Typography.Text>
            <Typography.Text>{record.signedAt}</Typography.Text>
          </div>
          <div>
            <Typography.Text strong>{t('signRequestsTable.procedure', { ns: 'sign-requests' })}:</Typography.Text>
            <Typography.Text ellipsis={true}>{record.documents[0].name}</Typography.Text>
          </div>
        </List.Item>
      )}
    />
  );
};
export default SignRequestsList;
